module.exports = __webpack_public_path__ + "static/media/samespace.7130bb62.svg";